import { defaultOf } from "../../../fable_modules/Feliz.2.9.0/../../WebParts/User/DokumentenDepot/../../../fable_modules/fable-library-js.4.19.0/Util.js";
import { append, empty, singleton, delay, toList } from "../../../fable_modules/fable-library-js.4.19.0/Seq.js";
import { spinner, Icons_DrawerSend2, checkbox, disabeldCheckboxWithTooltipSingleline } from "../../../../Bfs.Web.Portale/ViewParts.fs.js";
import { Msg } from "./Types.fs.js";
import * as react from "react";
import { comparePrimitives, int32ToString } from "../../../fable_modules/fable-library-js.4.19.0/Util.js";
import { asString } from "../../../../Bfs.Web.Data.Service.Contracts/Shared.fs.js";
import { map, filter, exists, length, sortBy, sortByDescending, ofArray, singleton as singleton_1 } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { desktopDataTable, mobileDataList } from "../Shared/DataList.fs.js";
import { messageBoxComponent } from "../../../../Bfs.Web.Portale/Template.fs.js";
import { GlobalMessageType } from "../../../../Bfs.Web.Portale/Types.fs.js";
import { keyValueList } from "../../../fable_modules/fable-library-js.4.19.0/MapUtil.js";
import { DashboardPage } from "../DashBoardPage.fs.js";
import { value } from "../../../fable_modules/fable-library-js.4.19.0/Option.js";

export function kannAuslagern(row) {
    if (row.AuslagerungAngefordert == null) {
        return row.ZeitAuslagerung == null;
    }
    else {
        return false;
    }
}

export function columnMappingMobile(model, dispatch) {
    let children_8;
    return ofArray([[defaultOf(), (row) => {
        let children_2, children;
        const children_4 = [(children_2 = [(children = toList(delay(() => (((row.AuslagerungAngefordert != null) ? true : (row.ZeitAuslagerung != null)) ? singleton(disabeldCheckboxWithTooltipSingleline((row.ZeitAuslagerung == null) ? "Dokument ist bereits für die Auslagerung vorgemerkt." : "Dokument ist bereits auf dem Postweg.", (_arg) => {
        })) : singleton(checkbox(row.IsChecked, (_arg_1) => {
            dispatch(new Msg(3, [row.LagerplatzReportId]));
        }, ""))))), react.createElement("div", {}, ...children))], react.createElement("div", {}, ...children_2))];
        return react.createElement("div", {}, ...children_4);
    }], ["SendungsNr", (row_1) => int32ToString(row_1.SendungNr)], ["Rechnungsnummer", (row_2) => row_2.RechnungsNrExtern], ["Klient/Patient", (row_3) => row_3.KlientPatient], ["Eingelagert", (row_4) => asString(row_4.EingelagertAm)], ["Art", (row_5) => row_5.DokumentArt], ["Grund", (row_6) => row_6.Grund], ["Rücksendung", (row_7) => {
        let matchValue_2;
        return (row_7.ZeitAuslagerung == null) ? ((row_7.AuslagerungAngefordert != null) ? "angefordert" : ((matchValue_2 = row_7.RuecksendungAm, (matchValue_2 == null) ? "" : asString(matchValue_2)))) : "Auf dem Postweg";
    }], [(children_8 = [react.createElement("div", {}, "")], react.createElement("div", {}, ...children_8)), (row_8) => {
        let children_10;
        const children_12 = [(children_10 = toList(delay(() => (kannAuslagern(row_8) ? singleton(Icons_DrawerSend2("Auslagern", (_arg_2) => {
            dispatch(new Msg(5, [singleton_1(row_8.LagerplatzReportId)]));
        })) : empty()))), react.createElement("div", {}, ...children_10))];
        return react.createElement("div", {}, ...children_12);
    }]]);
}

export function columnMappingDesktop(model, dispatch) {
    let children, children_6, children_16;
    return ofArray([[(children = [checkbox(model.AllChecked, (_arg) => {
        dispatch(new Msg(4, []));
    }, "")], react.createElement("div", {
        className: "normalSize-checkbox",
    }, ...children)), (row) => (((row.AuslagerungAngefordert != null) ? true : (row.ZeitAuslagerung != null)) ? disabeldCheckboxWithTooltipSingleline((row.ZeitAuslagerung == null) ? "Dokument ist bereits für die Auslagerung vorgemerkt." : "Dokument ist bereits auf dem Postweg.", (_arg_1) => {
    }) : checkbox(row.IsChecked, (_arg_2) => {
        dispatch(new Msg(3, [row.LagerplatzReportId]));
    }, ""))], ["SendungsNr", (row_1) => int32ToString(row_1.SendungNr)], ["Rechnungsnummer", (row_2) => row_2.RechnungsNrExtern], ["Klient/Patient", (row_3) => row_3.KlientPatient], ["Art", (row_4) => row_4.DokumentArt], ["Grund", (row_5) => row_5.Grund], [(children_6 = [react.createElement("div", {}, "Eingelagert"), react.createElement("div", {}, "Rücksendung")], react.createElement("div", {}, ...children_6)), (row_6) => {
        const children_12 = toList(delay(() => {
            let children_8;
            return (row_6.ZeitAuslagerung == null) ? ((row_6.AuslagerungAngefordert != null) ? singleton("angefordert") : append(singleton((children_8 = [asString(row_6.EingelagertAm)], react.createElement("div", {}, ...children_8))), delay(() => {
                let children_10, matchValue_2;
                return singleton((children_10 = [(matchValue_2 = row_6.RuecksendungAm, (matchValue_2 == null) ? "" : asString(matchValue_2))], react.createElement("div", {}, ...children_10)));
            }))) : singleton("Auf dem Postweg");
        }));
        return react.createElement("div", {}, ...children_12);
    }], [(children_16 = [react.createElement("div", {}, "Aktion")], react.createElement("div", {}, ...children_16)), (row_7) => {
        let children_18;
        const children_20 = [(children_18 = toList(delay(() => (kannAuslagern(row_7) ? singleton(Icons_DrawerSend2("Auslagern", (_arg_3) => {
            dispatch(new Msg(5, [singleton_1(row_7.LagerplatzReportId)]));
        })) : empty()))), react.createElement("div", {}, ...children_18))];
        return react.createElement("div", {}, ...children_20);
    }]]);
}

export function mobileTable(data, model, dispatch) {
    let data_1;
    const children = [checkbox(model.AllChecked, (_arg) => {
        dispatch(new Msg(4, []));
    }, ""), (data_1 = sortByDescending((x_2) => x_2.SendungNr, sortBy((x) => x.KlientPatient, data, {
        Compare: comparePrimitives,
    }), {
        Compare: comparePrimitives,
    }), mobileDataList("Keine eingegangenen Belege.", columnMappingMobile(model, dispatch), data_1))];
    return react.createElement("div", {
        className: "is-hidden-desktop",
    }, ...children);
}

export function desktopTable(data, model, dispatch) {
    const data_1 = sortByDescending((x_2) => x_2.SendungNr, sortBy((x) => x.KlientPatient, data, {
        Compare: comparePrimitives,
    }), {
        Compare: comparePrimitives,
    });
    return desktopDataTable("Keine eingegangenen Belege.", columnMappingDesktop(model, dispatch), data_1);
}

export function confirmationDialog(lagerplatzReportIds, dispatch) {
    let children, s, props_8, children_6;
    return messageBoxComponent(new GlobalMessageType(1, []), false, (length(lagerplatzReportIds) === 1) ? "Ein Dokument zur Auslagerung ausgewählt" : (`${length(lagerplatzReportIds)} Dokumente zur Auslagerung ausgewählt`), (children = [(s = "Nach Eingang Ihrer Anforderung werden Ihre Dokumente noch am selben Tag, spätestens jedoch am folgenden Werktag, an Sie zurückgesandt.", s), react.createElement("br", {}), "Sollen die Dokumente jetzt ausgelagert werden?"], react.createElement("div", {}, ...children)), () => {
        dispatch(new Msg(8, []));
    }, [(props_8 = [["style", {
        display: "flex",
        alignItems: "baseline",
    }]], (children_6 = [react.createElement("button", {
        className: "button white-button",
        onClick: (_arg) => {
            dispatch(new Msg(8, []));
        },
    }, "Abbrechen"), react.createElement("button", {
        className: "button is-bfscolored",
        onClick: (_arg_1) => {
            dispatch(new Msg(6, [lagerplatzReportIds]));
        },
    }, "Jetzt auslagern")], react.createElement("div", keyValueList(props_8, 1), ...children_6)))]);
}

export function erfolgsmeldungDialog(anzahlDokumente, dispatch) {
    let children, props_4, children_4;
    return messageBoxComponent(new GlobalMessageType(1, []), false, "Erfolgreich ausgelagert", (children = [(anzahlDokumente === 1) ? "Es wurde ein Dokument erfolgreich ausgelagert." : (`Es wurden ${anzahlDokumente} Dokumente erfolgreich ausgelagert.`)], react.createElement("div", {}, ...children)), () => {
        dispatch(new Msg(8, []));
    }, [(props_4 = [["style", {
        display: "flex",
        alignItems: "baseline",
    }]], (children_4 = [react.createElement("button", {
        className: "button is-bfscolored",
        onClick: (_arg) => {
            dispatch(new Msg(8, []));
        },
    }, "OK")], react.createElement("div", keyValueList(props_4, 1), ...children_4)))]);
}

export function view(model, dispatch, navigateTo) {
    if (model.Loading) {
        return spinner;
    }
    else {
        const children_12 = toList(delay(() => {
            let children_8;
            return append(singleton((children_8 = toList(delay(() => {
                let children_4, children_2;
                return append(singleton((children_4 = [(children_2 = [react.createElement("i", {
                    className: "fas fa-angle-left mr-2",
                }), "Zurück zum Dashboard"], react.createElement("a", {
                    onClick: (_arg) => {
                        navigateTo(new DashboardPage());
                    },
                }, ...children_2))], react.createElement("div", {}, ...children_4))), delay(() => {
                    let children_6;
                    return exists((x) => x.IsChecked, filter(kannAuslagern, model.Data)) ? singleton((children_6 = toList(delay(() => {
                        let matchValue_1;
                        const lagerplatzReportIds = map((x_2) => x_2.LagerplatzReportId, filter((x_1) => x_1.IsChecked, model.Data));
                        return singleton(Icons_DrawerSend2((matchValue_1 = (length(lagerplatzReportIds) | 0), (matchValue_1 === 1) ? "1 Dokument auslagern" : (int32ToString(matchValue_1) + " Dokumente auslagern")), (_arg_1) => {
                            dispatch(new Msg(5, [lagerplatzReportIds]));
                        }));
                    })), react.createElement("div", {}, ...children_6))) : empty();
                }));
            })), react.createElement("div", {
                className: "card-title",
            }, ...children_8))), delay(() => {
                let children_10;
                return append(singleton((children_10 = [mobileTable(model.Data, model, dispatch), desktopTable(model.Data, model, dispatch)], react.createElement("div", {
                    className: "card-body",
                }, ...children_10))), delay(() => {
                    let matchValue_2;
                    return append(model.ShowAuslagernSuccessDialog ? singleton(erfolgsmeldungDialog((matchValue_2 = model.DokumenteZumAuslagern, (matchValue_2 == null) ? 0 : length(matchValue_2)), dispatch)) : empty(), delay(() => (((model.DokumenteZumAuslagern != null) && (model.ShowAuslagernSuccessDialog === false)) ? singleton(confirmationDialog(value(model.DokumenteZumAuslagern), dispatch)) : empty())));
                }));
            }));
        }));
        return react.createElement("div", {
            className: "flat-card profile-info-card is-auto overflow-initial",
        }, ...children_12);
    }
}

//# sourceMappingURL=View.fs.js.map
